import SkillApi from '@/api/skill/skill.js'

const state = {
    skills: [],
    skill_category: [],
    skill_category_info: [{0: 1, 1: 2, 2: 3}, {0: 2, 1: 5, 2: 8}],
    current_category: '',
    star: {},
    domain_str: '',
    star_on_img: '/static/img/star_on_48.png',
    star_off_img: '/static/img/star_off_48.png',
    star_blue_img: '/static/img/star_blue_48.png',
    years: []
}

const mutations = {
    get_self_score(state, skills) {
        state.skills = skills
    },
    get_categories(state, category) {
        state.skill_category = category
    },
    get_skill_from_category(state, skills) {
        state.skills = skills
    },
    set_current_category(state, category) {
        state.current_category = category
    },
    skill_category_info(state, category) {
        state.skill_category_info = category
    },
    set_star(state, star) {
        var obj = Object.create(state.star)
        obj[star[1]] = star[0]
        state.star = obj
    },
    set_years(state, years) {
        state.years = years
    },
    reset_star(state, star) {
        state.star = star
    }
}
var state_int = {
    'skilled': 4,
    'well': 3,
    'ordinary': 2,
    'understood': 1,
    'incompetent': 0,
}
const actions = {
    async get_self_score(context) {
        let res = await SkillApi.get_self_score()
        context.commit('get_self_score', res.data)
    },
    async get_skill_category_info(context) {
        let res = await SkillApi.get_skill_category_info()
        context.commit('skill_category_info', res.data)
    },
    async check_user_skill() {
        await SkillApi.check_user_skill()
    },
    async change_current_category(context, category) {
        context.commit('set_current_category', category)
        let skills = {}
        state.skill_category.forEach(ca=>{
            if(ca.id === state.current_category.id){
                skills = ca.skills
            }
        })
        // let skills = await SkillApi.get_skill_from_category(state.current_category.id)
        context.commit('get_skill_from_category', skills)
    },
    async set_skill_plan(context, event) {
        let temp = await SkillApi.set_skill_plan({
            'skill_id': event.target.getAttribute('data-skill-id'),
            'index': event.target.getAttribute('data-index'),
            'old_state': event.target.getAttribute('data-state'),
            'year': event.target[event.target.selectedIndex].value,
            'category_id': context.state.current_category.id,
        })
        // let temp = await SkillApi.get_skill_and_plan_from_category(context.state.current_category.id)
        temp = JSON.parse(temp.data.result)
        for (var x = 0; x < temp.length; x++) {
            var star = {'star': context.state.star_on_img, 'year': ''}
            var e_star = {'star': context.state.star_off_img, 'year': ''}
            var star_state = temp[x]
            var plans = temp[x].plan
            var res_temp = {}
            if (star_state.state) {
                if (star_state.state === 'skilled') {
                    res_temp = {0: star, 1: star, 2: star, 3: star, 4: star}
                } else if (star_state.state === 'well') {
                    res_temp = {0: star, 1: star, 2: star, 3: star, 4: e_star}
                } else if (star_state.state === 'ordinary') {
                    res_temp = {0: star, 1: star, 2: star, 3: e_star, 4: e_star}
                } else if (star_state.state === 'understood') {
                    res_temp = {0: star, 1: star, 2: e_star, 3: e_star, 4: e_star}
                } else if (star_state.state === 'incompetent') {
                    res_temp = {0: star, 1: e_star, 2: e_star, 3: e_star, 4: e_star}
                }
            } else {
                res_temp = {0: e_star, 1: e_star, 2: e_star, 3: e_star, 4: e_star}
            }
            if (plans) {
                for (var t = 0; t < plans.length; t++) {
                    res_temp[state_int[plans[t].target]] = {'star': context.state.star_blue_img, 'year': plans[t].year}
                }
            }
            context.commit('set_star', [res_temp, star_state.id])
        }
    },
    async get_categories(context) {
        let domain = localStorage.getItem('field')
        let res = await SkillApi.get_category_skill_info_for_plan({'domain': domain})
        // let res = await SkillApi.get_categories({'domain': domain})
        // let obj = JSON.parse(res.data.result)
        let obj = res.data
        context.commit('get_categories', obj)
        context.commit('set_current_category', obj[0])
        var today = new Date()
        var now_year = today.getFullYear()
        context.commit('set_years', ['', now_year, now_year + 1, now_year + 2])
        for (var i = 0; i < obj.length; i++) {
            // let temp = await SkillApi.get_skill_and_plan_from_category(obj[i].id)
            let temp = obj[i].skills
            for (var x = 0; x < temp.length; x++) {
                var star = {'star': context.state.star_on_img, 'year': ''}
                var e_star = {'star': context.state.star_off_img, 'year': ''}
                var star_state = temp[x]
                // var star_state = temp.data[x]
                // var plans = temp.data[x].plan
                var plans = temp[x].plan
                console.log(temp[x])
                var res_temp = {}
                if (star_state.state) {
                    if (star_state.state === 'skilled') {
                        res_temp = {0: star, 1: star, 2: star, 3: star, 4: star}
                    } else if (star_state.state === 'well') {
                        res_temp = {0: star, 1: star, 2: star, 3: star, 4: e_star}
                    } else if (star_state.state === 'ordinary') {
                        res_temp = {0: star, 1: star, 2: star, 3: e_star, 4: e_star}
                    } else if (star_state.state === 'understood') {
                        res_temp = {0: star, 1: star, 2: e_star, 3: e_star, 4: e_star}
                    } else if (star_state.state === 'incompetent') {
                        res_temp = {0: star, 1: e_star, 2: e_star, 3: e_star, 4: e_star}
                    }
                } else {
                    res_temp = {0: e_star, 1: e_star, 2: e_star, 3: e_star, 4: e_star}
                }
                if (plans) {
                    for (var t = 0; t < plans.length; t++) {
                        res_temp[state_int[plans[t].target]] = {'star': context.state.star_blue_img, 'year': plans[t].year}
                    }
                }
                context.commit('set_star', [res_temp, star_state.id])
            }
        }

        let skills = obj[0].skills
        context.commit('get_skill_from_category', skills)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
